export default class Calculator {
  constructor() {
    this.setVars()
  }
  
  setVars() {
    this.settings = {
      init: 'data-calc',
      invoice_range: 'data-calc-invoice-range',
      invoice_number: 'data-calc-invoice-number',
      term_number: 'data-calc-term-number',
      term_range: 'data-calc-term-range',
      to_payment: 'data-calc-value-to-payment',
      to_cost: 'data-calc-value-to-cost',
    };
    
    this.calcs = document.querySelectorAll(`[${this.settings.init}]`);
    if (!this.calcs) return false;
    
    this.setEvents();
  }
  
  setEvents() {
    
    this.calcs.forEach(calc => {
      const invoice_number = calc.querySelector(`[${this.settings.invoice_number}]`);
      const invoice_range = calc.querySelector(`[${this.settings.invoice_range}]`);
      const term_range = calc.querySelector(`[${this.settings.term_range}]`);
      const term_number = calc.querySelector(`[${this.settings.term_number}]`);
      const to_payment = calc.querySelector(`[${this.settings.to_payment}]`);
      const to_cost = calc.querySelector(`[${this.settings.to_cost}]`);
      
      this.changeValues(invoice_number, invoice_number, invoice_range, invoice_number, term_number, to_payment, to_cost);
      this.inputValues(invoice_range, invoice_number, invoice_range);
  
      this.changeValues(term_number, term_number, term_range, invoice_number, term_number, to_payment, to_cost);
      this.inputValues(term_range, term_number, term_range);
  
      this.setPayment(to_payment, to_cost, invoice_number, term_number);
    });
  }
  
  changeValues(element, change1, change2, invoice_number, term_number, to_payment, to_cost) {
    element.addEventListener('change', () => {
      const value = parseInt(change1.value);
      const min = parseInt(change1.getAttribute('min'));
      const max = parseInt(change1.getAttribute('max'));
    
      if (value > max) {
        change1.value = max;
      }
    
      if (value < min) {
        change1.value = min;
      }
  
      change2.value = value;
      change2.parentNode.style.setProperty('--value', value);
  
      this.setPayment(to_payment, to_cost, invoice_number, term_number);
    });
  }
  
  inputValues(element, change1, change2) {
    element.addEventListener('input', () => {
      change1.value = change2.value;
      change1.parentNode.style.setProperty('--value', change2.value);
      change1.triggerEvent('change');
    });
  }
  
  setPayment(to_payment, to_cost, invoice_number, term_number) {
    const invoiceValue = parseInt(invoice_number.value);
    const invoiceValueAfterCost = invoiceValue * 0.9;
    const termValue = parseInt(term_number.value);
    const cost = (invoiceValue - (invoiceValue - (invoiceValue * ((0.026 * termValue) / 100))));
    const to_payed = invoiceValueAfterCost - cost;
    
    to_payment.innerHTML = this.number_format(to_payed, 2,',', ' ');
    to_cost.innerHTML = this.number_format(cost, 2,',', ' ');
  }
  
  number_format(number, decimals, dec_point, thousands_sep) {
    var n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
      sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
      dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
      toFixedFix = function (n, prec) {
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        var k = Math.pow(10, prec);
        return Math.round(n * k) / k;
      },
      s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split('.');
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
  }
}
